import React  from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  TextField,
  Typography,
  InputAdornment
} from '@mui/material';
import { styled } from '@mui/material/styles';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import GroupIcon from '@mui/icons-material/Group';
const StyledTableRow = styled(TableRow)(({ theme, isActive }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: 'white',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    backgroundColor: '#ffff',
  },
}));

const StyledSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#4169E1',
    '&:hover': {
      backgroundColor: 'gre',
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#4169E1',
  },
}));

const NoDataTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  textAlign: 'center',
  padding: theme.spacing(2),
}));

const TimeSlotTable = ({ slots, handleChange }) => {
  if (!slots || slots.length === 0) {
    return (
      <TableContainer component={Paper}>
        <NoDataTypography variant="h6">
          No data
        </NoDataTypography>
      </TableContainer>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table aria-label="time slot table">
        <TableHead>
          <TableRow>
            <TableCell>รอบ</TableCell>
            <TableCell align="center">จำนวนผู้โดยสาร</TableCell>
            <TableCell align="center">ราคา ผู้ใหญ่</TableCell>
            <TableCell align="center">ราคาเด็ก</TableCell>
            <TableCell align="center">เปิดให้บริการ</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {slots.map((slot, index) => (
            <StyledTableRow key={index} isActive={slot.status === "active"}>
              <TableCell component="th" scope="row">
                <AccessTimeIcon sx={{ mr: 1, verticalAlign: 'middle' }} fontSize='14px' />
                {slot.time}
              </TableCell>
              <TableCell align="center">
                <TextField
                  type="number"
                  value={slot.total_people || 0} 
                  onChange={(e) => {
                    const newValue = e.target.value === "" ? 0 : Number(e.target.value);
                    handleChange(index, 'total_people', newValue);
                  }}
                  variant="outlined"
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <GroupIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <Typography>
                        คน
                      </Typography>
                    ),
                  }}
                />
              </TableCell>
              <TableCell align="center">
                <TextField
                  type="number"
                  value={slot.price_adult || 0} 
                  onChange={(e) => {
                    const newValue = e.target.value === "" ? 0 : Number(e.target.value);
                    handleChange(index, 'price_adult', newValue);
                  }}
                  variant="outlined"
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <Typography>
                        บาท
                      </Typography>
                    ),
                  }}
                />
              </TableCell>
              <TableCell align="center">
                <TextField
                  type="number"
                  value={slot.price_children || 0}
                  onChange={(e) => {
                    const newValue = e.target.value === "" ? 0 : Number(e.target.value);
                    handleChange(index, 'price_children', newValue);
                  }}
                  variant="outlined"
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <Typography>
                        บาท
                      </Typography>
                    ),
                  }}
                />
              </TableCell>
              <TableCell align="center">
                <StyledSwitch
                  checked={slot.status === "active"}
                  onChange={() => handleChange(index, 'status', slot.status === "active" ? "inactive" : "active")}
                  size="small"
                />
              </TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TimeSlotTable;
